import React from "react";
import { Modal, Button, Spinner, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { namespaces } from "../../i18n/i18n.constants";
import { FaExclamationTriangle } from "react-icons/fa";
import "./ConfirmModal.scss";

interface Props {
    isShow: boolean;
    title?: string;
    message: string;
    confirmLabel?: string;
    cancelLabel?: string;
    confirmVariant?: string;
    isLoading?: boolean;
    onConfirm: () => void;
    onClose: () => void;
}

const ConfirmModal: React.FC<Props> = ({
    isShow,
    title,
    message,
    confirmLabel,
    cancelLabel,
    confirmVariant = "primary",
    isLoading = false,
    onConfirm,
    onClose,
}) => {
    const { t } = useTranslation();

    return (
        <Modal
            show={isShow}
            size="lg"
            onHide={onClose}
            backdrop="static"
            backdropClassName="blur-backdrop"
            centered
            fullscreen="sm-down"
            className="confirm-modal"
            contentClassName="confirm-modal-content"
        >
            <Modal.Header closeButton className="px-5">
                <div className="d-flex align-items-center flex-grow-1">
                    <div className="pe-3 text-warning">
                        <FaExclamationTriangle size={24} />
                    </div>
                    <span className="fs-4 fw-bold">
                        {title ?? t("commonTitles.confirmation", { ns: namespaces.modals })}
                    </span>
                </div>
            </Modal.Header>
            <Modal.Body className="py-4 px-5">
                <Row className="d-flex justify-content-center text-center">
                    <p className="fs-5">{message}</p>
                </Row>
                <Row>
                    <Col>
                        <Button
                            variant={confirmVariant}
                            className="w-100 my-3 p-3"
                            onClick={onConfirm}
                            disabled={isLoading}
                        >
                            {isLoading ? (
                                <Spinner animation="border" size="sm" />
                            ) : (
                                confirmLabel ?? t("buttons.confirm", { ns: namespaces.common })
                            )}
                        </Button>
                    </Col>
                    <Col>
                        <Button
                            variant="secondary"
                            className="w-100 my-3 p-3"
                            onClick={onClose}
                            disabled={isLoading}
                        >
                            {cancelLabel ?? t("buttons.cancel", { ns: namespaces.common })}
                        </Button>
                    </Col>
                </Row>
            </Modal.Body>
        </Modal>
    );
};

export default ConfirmModal;
